import { rpc } from '../lib/Rpc'
import { loggerNamespace } from '../lib/Logger'
import { TResource, create } from '../models/Resource'

class ResourceService {
  private logger = loggerNamespace('ResourceService')

  public getBusinessResources = async (businessId: string): Promise<TResource[]> => {
    const { error, result } = await rpc.call('resource.get_business_resources', {
      business: { id: businessId },
    })
    return Array.isArray(result) ? result.map(create) : []
  }
}

const resourceService = new ResourceService()
export { resourceService }
